import $ from 'jquery';

window.$ = $;
window.jQuery = $;

globalThis.$ = $;
globalThis.jQuery = $;

/**
 * Compatibility shim for old legacy jQuery plugins that call require('jquery')
 * when bundled through Vite.
 */
if (!globalThis.require) {
    globalThis.require = function (name) {
        if (name === 'jquery') {
            return globalThis.jQuery;
        }

        throw new Error('Unsupported browser require: ' + name);
    };
}

window.require = globalThis.require;

/*
import '../jquery.min.js';

const legacyJQuery = window.jQuery || window.$;

if (legacyJQuery) {
    window.jQuery = legacyJQuery;
    window.$ = legacyJQuery;
    globalThis.jQuery = legacyJQuery;
    globalThis.$ = legacyJQuery;
}
*/